/**
 * Asynchronously loads the component for InvestmentHoldings
 */
import React, { lazy, Suspense } from 'react';
import LoadingView from 'components/LoadingView';
import retryPromise from 'utils/retryPromise';
const Component = lazy(() => retryPromise(() => import('./index')));

const loadable = (props: Record<string, any>) =>
  <Suspense fallback={<LoadingView />}>
    <Component {...props} />
  </Suspense>;

export default loadable;
